import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const CodeWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
`
const InputCode = styled.input`
    width: 43px;
    height: 30px;
    padding: 10px;
    border-radius: 7.494px;
    border: 1px solid #FF7624;
    outline: none;
    background-color: #fff;
    color: #454545;
    font-family: Roboto;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 14.989px;
    text-align: center;

    @media screen and (max-width: 767px){
        width: 24px;
        height: 18px;
    }
`

const CodeInputBox = ({ codes, setCodes, handleProceed }) => {
    // const [triggerBack, setTriggerBack] = useState(true);
    const refs = useRef([]);

    useEffect(() => {
        refs.current[0]?.focus();
    }, []);

    const handleInputChange = (event, index) => {
        // setTriggerBack(false);
        const numberRejex = /^[0-9]*$/;
        // const value = event.key;
        const value = event.target.value;


        // if (value == 'Backspace') {
        //     setCodes((prevCodes) => {
        //         const newCodes = [...prevCodes];
        //         newCodes[index] = '';
        //         return newCodes;
        //     });

        //     if (index > 0) {
        //         refs.current[index - 1]?.focus();
        //         // event.target.select();
        //     }
        // } else

        if (numberRejex.test(value)) {

            setCodes((prevCodes) => {
                const newCodes = [...prevCodes];
                newCodes[index] = value;
                return newCodes;
            });

            if (index < codes.length && value != '') {
                refs.current[index + 1]?.focus();
                // event.target.select();
            }
        }
    }

    const handleEnterClick = (event) => {
        if (event.key == "Enter") {
            handleProceed();
        }
    };

    // const checkBackspace = (event, index) => {
    //     if (!triggerBack) {
    //         setTriggerBack(true);
    //         return;
    //     }

    //     const key = event.key;
    //     if (key == 'Backspace') {
    //         // setCodes((prevCodes) => {
    //         //     const newCodes = [...prevCodes];
    //         //     newCodes[index] = '';
    //         //     return newCodes;
    //         // });

    //         if (index > 0) {
    //             refs.current[index - 1]?.focus();
    //             // event.target.select();
    //         }
    //     }
    // }

    return (
        <CodeWrap>
            {codes.map((code, index) => (
                <InputCode
                    key={index}
                    ref={(el) => (refs.current[index] = el)}
                    value={code}
                    onChange={(event) => handleInputChange(event, index)}
                    maxLength={1}
                    val={codes[index]}
                    onKeyPress={handleEnterClick}
                // onKeyDown={(event) => checkBackspace(event, index)}
                />
            ))}
        </CodeWrap>
    );
}

export default CodeInputBox;